import script from "./Monthlies.vue?vue&type=script&setup=true&lang=js"
export * from "./Monthlies.vue?vue&type=script&setup=true&lang=js"

import "./Monthlies.vue?vue&type=style&index=0&id=9f851a40&lang=scss&scoped=true"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f851a40"]])

export default __exports__